<template>
    <div v-loading="carregando">
        <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="24" :sm="12" :md="8">
                <el-input v-model="busca" clearable placeholder="Pesquisar por código ou descrição">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </el-col>
            <el-col :xs="24" :sm="4" :md="4" class="u-mt-5">
                <el-checkbox v-model="somenteExibidos">Só os exibidos</el-checkbox>
            </el-col>
            <el-col :xs="24" :sm="8" :md="12" class="u-text-right">
                <span class="resumo">{{ resumo }}</span>
                <el-button v-if="permiteLocal" size="small" icon="el-icon-plus" plain @click="abrirModal()">NOVO TIPO</el-button>
                <el-button type="primary" size="small" icon="el-icon-check" @click="salvar" :disabled="!alterado">
                    SALVAR
                </el-button>
            </el-col>
        </el-row>

        <div class="container-table" style="max-height: 520px; overflow-y: auto;">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 70px;">Código</th>
                        <th>Descrição</th>
                        <th v-if="temLotacao" title="Instituição do cadastro interno correspondente a esta unidade">Instituição do sistema</th>
                        <th v-if="temLotacao" class="u-text-center" title="Servidores ativos lotados neste local">Servidores</th>
                        <th style="width: 95px;" class="u-text-center" title="Aparece na lista do lançamento">Exibe</th>
                        <th style="width: 75px;" class="u-text-center" title="Posição na lista do lançamento">Ordem</th>
                        <template v-if="exportavel">
                            <th style="width: 105px;" class="u-text-center">Gera eventual?</th>
                            <th style="width: 220px;">Evento de destino</th>
                            <th style="width: 110px;">Digitação</th>
                            <th style="width: 105px;" class="u-text-center"
                                title="Tipo de dia que também pode ser lançado com ausência em horas">Aceita horas</th>
                            <th style="width: 130px;" title="Campos extras exibidos no lançamento">Pede no lançamento</th>
                        </template>
                        <th v-if="temJustificativa" style="width: 160px;" class="u-text-center">{{ rotuloJustificativa }}</th>
                        <th v-if="permiteLocal" style="width: 90px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filtrados" :key="item.codigo">
                        <td>{{ item.codigo }}</td>
                        <td>{{ item.descricao }}</td>
                        <td v-if="temLotacao">
                            <el-select v-model="item.instituicao_id" filterable clearable size="mini"
                                placeholder="Não associada" style="width: 100%;" @change="alterado = true">
                                <el-option v-for="i in internas" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </td>
                        <td v-if="temLotacao" class="u-text-center">
                            <span :class="item.servidores ? '' : 'u-text-muted'">{{ item.servidores }}</span>
                        </td>
                        <td class="u-text-center">
                            <el-switch v-model="item.habilitado" @change="alterado = true"></el-switch>
                        </td>
                        <td class="u-text-center">
                            <el-input-number v-model="item.ordem" :min="0" :controls="false" size="mini"
                                style="width: 60px;" @change="alterado = true"></el-input-number>
                        </td>

                        <template v-if="exportavel">
                            <td class="u-text-center">
                                <el-switch v-model="item.exporta" @change="alterado = true"></el-switch>
                            </td>
                            <td>
                                <el-select v-model="item.evento_cod" :disabled="!item.exporta" filterable clearable
                                    size="mini" placeholder="Selecione o evento" style="width: 100%;" @change="alterado = true">
                                    <el-option v-for="e in eventos" :key="e.codigo" :label="e.codigo + ' - ' + e.descricao" :value="e.codigo"></el-option>
                                </el-select>
                                <div v-if="item.exporta && !item.evento_cod" class="aviso-celula">
                                    Sem evento apontado — não entra no arquivo.
                                </div>
                            </td>
                            <td>
                                <el-select v-model="item.tipo_lancamento" :disabled="!item.exporta" size="mini"
                                    style="width: 100%;" @change="alterado = true">
                                    <el-option label="Dias" value="D"></el-option>
                                    <el-option label="Horas" value="H"></el-option>
                                    <el-option label="Valor" value="V"></el-option>
                                </el-select>
                            </td>
                            <td class="u-text-center">
                                <!-- Só faz sentido em tipo de dia: quem já é 'H' aparece
                                     na ausência Horas de qualquer jeito. -->
                                <el-checkbox v-if="item.tipo_lancamento !== 'H'" v-model="item.permite_horas"
                                    @change="alterado = true"></el-checkbox>
                                <span v-else class="u-text-muted" title="Já é digitado em horas">—</span>
                            </td>
                            <td>
                                <el-checkbox v-model="item.pede_medico" @change="alterado = true">Médico/CRM</el-checkbox>
                                <el-checkbox v-model="item.pede_cid" @change="alterado = true">CID</el-checkbox>
                            </td>
                        </template>
                        <td v-if="temJustificativa" class="u-text-center">
                            <el-switch v-model="item.justificativa" @change="alterado = true"></el-switch>
                        </td>

                        <td v-if="permiteLocal" class="u-text-center acao">
                            <template v-if="item.local">
                                <el-button @click="abrirModal(item)" title="Renomear" type="info" icon="el-icon-edit" size="mini" plain></el-button>
                                <el-button @click="excluir(item)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </template>
                            <span v-else class="u-text-muted">—</span>
                        </td>
                    </tr>
                    <tr v-if="!filtrados.length">
                        <td :colspan="colunas" class="u-text-center">
                            {{ carregando ? 'Carregando o catálogo do RH...' : 'Nenhum item encontrado.' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <el-dialog :title="form.id ? 'Renomear tipo' : 'Novo tipo'" :visible.sync="modal" width="480px" :close-on-click-modal="false" append-to-body>
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Descrição">
                            <el-input v-model="form.descricao" maxlength="120" placeholder="Ex.: RECESSO ESCOLAR"
                                @keyup.enter.native="salvarTipo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="Código">
                            <el-input v-model="form.codigo" maxlength="10" :disabled="!!form.id"
                                placeholder="Automático se em branco"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Ordem na lista">
                            <el-input-number v-model="form.ordem" :min="0" :controls="false" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-alert type="info" :closable="false" :title="ajudaModal"></el-alert>
            </el-form>
            <span slot="footer">
                <el-button @click="modal = false">CANCELAR</el-button>
                <el-button type="primary" @click="salvarTipo" :loading="salvandoTipo">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// Grid de curadoria sobre um catálogo do SIP. Três modos:
//
//   falta       -> de/para com o evento do arquivo TXT + campos do atestado
//   afastamento -> não vai para o TXT; só a justificativa automática da aba Folha
//   instituicao -> só exibição e ordem, com a lotação de cada local
//
// Nos dois primeiros a lista soma o catálogo do SIP (somente leitura) aos tipos
// cadastrados pelo município. Em instituições não há cadastro local: o código é
// o vínculo do servidor no SIP.
export default {
    name: 'AbaCatalogo',
    props: {
        recurso: { type: String, required: true },   // endpoint em /configuracao
        modo: { type: String, default: 'falta' },    // falta | afastamento | instituicao
        catalogo: { type: String, default: '' },     // catálogo dos tipos locais
        rotuloJustificativa: { type: String, default: 'Entra na justificativa' },
        eventos: { type: Array, default: () => [] }
    },
    data: () => ({
        carregando: true,
        alterado: false,
        busca: '',
        somenteExibidos: false,
        itens: [],
        internas: [],
        modal: false,
        salvandoTipo: false,
        form: { id: '', descricao: '', ordem: 0 }
    }),
    computed: {
        exportavel () { return this.modo === 'falta' },
        temJustificativa () { return this.modo === 'afastamento' },
        permiteLocal () { return this.modo !== 'instituicao' },
        temLotacao () { return this.modo === 'instituicao' },
        colunas () {
            // código + descrição + exibe + ordem
            return 4 + (this.temLotacao ? 2 : 0) + (this.exportavel ? 4 : 0)
                + (this.temJustificativa ? 1 : 0) + (this.permiteLocal ? 1 : 0)
        },
        filtrados () {
            const termo = (this.busca || '').trim().toUpperCase()

            let lista = this.itens

            if (this.somenteExibidos) lista = lista.filter(i => i.habilitado)

            if (termo) {
                lista = lista.filter(i =>
                    String(i.codigo).toUpperCase().indexOf(termo) === 0 ||
                    (i.descricao || '').toUpperCase().indexOf(termo) !== -1
                )
            }

            // Os exibidos vêm primeiro, na ordem do lançamento: com 55 códigos na
            // tela, os que estão em uso precisam estar à mão.
            return lista.slice().sort((a, b) => {
                if (a.habilitado !== b.habilitado) return a.habilitado ? -1 : 1
                const oa = a.ordem > 0 ? a.ordem : Number.MAX_SAFE_INTEGER
                const ob = b.ordem > 0 ? b.ordem : Number.MAX_SAFE_INTEGER
                return oa === ob ? (a.descricao || '').localeCompare(b.descricao || '') : oa - ob
            })
        },
        resumo () {
            const exibidos = this.itens.filter(i => i.habilitado).length
            const onde = this.temLotacao ? 'exibidas nos selects' : 'exibidos no lançamento'

            return `${exibidos} de ${this.itens.length} ${onde}`
        },
        ajudaModal () {
            const comum = 'O código não pode repetir nem colidir com um código do sistema de RH, e não muda depois de criado.'

            return this.exportavel
                ? `${comum} Ele nunca vai para o arquivo: para exportar, aponte um evento do RH na coluna "Evento de destino".`
                : `${comum} Reaproveitar o código do sistema antigo facilita uma futura importação dos lançamentos.`
        }
    },
    mounted () {
        this.load()

        if (this.temLotacao) this.getInternas()
    },
    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto/configuracao`
        },
        // Cadastro interno de instituições — é o único ponto do módulo que o
        // consulta; em todo o resto a folha trabalha com as unidades do SIP.
        getInternas () {
            this.$axios.get(`${this.baseUrl()}/instituicoes-internas`, this.$store.getters.getHeaderAuth)
                .then(res => { this.internas = res.data || [] })
                .catch(e => this.$emit('erro', e))
        },
        load () {
            this.carregando = true
            this.$axios.get(`${this.baseUrl()}/${this.recurso}`, this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.itens = (res.data || []).map(i => Object.assign({}, i))
                    this.alterado = false
                    this.carregando = false
                })
                .catch(e => { this.carregando = false; this.$emit('erro', e) })
        },
        salvar () {
            const itens = this.itens.map(i => {

                const item = { codigo: i.codigo, habilitado: !!i.habilitado, ordem: Number(i.ordem) || 0 }

                if (this.exportavel) {
                    Object.assign(item, {
                        exporta: !!i.exporta,
                        evento_cod: i.evento_cod || '',
                        tipo_lancamento: i.tipo_lancamento,
                        permite_horas: !!i.permite_horas,
                        pede_medico: !!i.pede_medico,
                        pede_cid: !!i.pede_cid
                    })
                }

                if (this.temLotacao) item.instituicao_id = i.instituicao_id || null

                if (this.temJustificativa) item.justificativa = !!i.justificativa

                return item
            })

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.baseUrl()}/${this.recurso}`, { itens }, this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.itens = (res.data || []).map(i => Object.assign({}, i))
                    this.alterado = false
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.$emit('erro', e) })
        },

        /* ------------------------- tipos do município ------------------------ */
        urlTipoLocal () {
            return `${this.baseUrl()}/tipo-local/${this.catalogo}`
        },
        abrirModal (item) {
            this.form = item
                ? { id: item.id, codigo: item.codigo, descricao: item.descricao, ordem: item.ordem, situacao: item.habilitado }
                : { id: '', codigo: '', descricao: '', ordem: 0, situacao: true }
            this.modal = true
        },
        salvarTipo () {
            if (!(this.form.descricao || '').trim()) {
                window.eventBus.$emit('alert', { msg: 'Informe a descrição do tipo.', type: 'warning' })
                return
            }

            this.salvandoTipo = true

            this.$axios.post(this.urlTipoLocal(), this.form, this.$store.getters.getHeaderAuth)
                .then(() => {
                    this.salvandoTipo = false
                    this.modal = false
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                    this.load()
                })
                .catch(e => { this.salvandoTipo = false; this.$emit('erro', e) })
        },
        excluir (item) {
            this.$msgbox.confirm(`Excluir o tipo "${item.descricao}"?`, 'Atenção', {
                confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning'
            }).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.urlTipoLocal()}/${item.id}`, this.$store.getters.getHeaderAuth)
                    .then(() => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                        this.load()
                    })
                    .catch(e => { window.eventBus.$emit('loading', false); this.$emit('erro', e) })
            }).catch(() => {})
        }
    }
}
</script>

<style scoped>
.resumo { color: #909399; font-size: 12px; margin-right: 12px; }
.aviso-celula { color: #e6a23c; font-size: 11px; margin-top: 3px; line-height: 1.3; }
.u-text-muted { color: #c0c4cc; }
td >>> .el-checkbox { display: block; margin-left: 0; margin-bottom: 2px; }
td >>> .el-checkbox__label { font-size: 12px; padding-left: 5px; }
</style>
